import { render, staticRenderFns } from "./TaskThemeChat.vue?vue&type=template&id=2e641566&scoped=true&"
import script from "./TaskThemeChat.vue?vue&type=script&lang=js&"
export * from "./TaskThemeChat.vue?vue&type=script&lang=js&"
import style0 from "./TaskThemeChat.vue?vue&type=style&index=0&id=2e641566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e641566",
  null
  
)

export default component.exports